// extracted by mini-css-extract-plugin
export default {"web":"web-rr1M"};